import { PageTitle } from "@/components/page-title";
import { InvoiceForm } from "./_form";
import { Invoice, Merchant, PropsWithUser } from "@/types";

type Props = {
  invoice: Invoice;
  merchants: Merchant[];
};

function InvoiceShow({ invoice, merchants }: PropsWithUser<Props>) {
  return (
    <div className="grid grid-cols-[1fr_400px] gap-4">
      <iframe src={invoice.file_url} className="h-full w-full" />

      <div>
        <PageTitle>Edit invoice</PageTitle>
        <InvoiceForm invoice={invoice} merchants={merchants} />
      </div>
    </div>
  );
}

export default InvoiceShow;
